<template>
  <div class="page-content">
    <page-template ref="scalesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="addColumns"
    ></page-template>

  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate,
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '类型',
              prop: 'type',
              type: 'select',
              data: this.$utils.getCacheStatus('mallNavigationCategory.type')
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
          },
        ],
        // 表格信息配置
        tableOptions: {
          showSelect: false,
          indexShow: true,//是否显示索引
          param: {pricingMethod: 30},
          columns: [
            {label: '标题', prop: 'name', width: '120', align: 'center'},
            {label: '图标', prop: 'imgUrl', width: '120', align: 'center', type: 'image'},
            {
              label: '类型',
              prop: 'type',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('mallNavigationCategory.type')
            },
            {label: '跳转', prop: 'typeDesc', width: '120', align: 'center'},
            {label: '关联', prop: 'goodsName', width: '120', align: 'center'},
            {label: '添加时间', prop: 'lastModifyDttm', width: '190', align: 'center'},
            {
              label: '状态',
              prop: 'openStatus',
              type: 'switch',
              width: '100',
              align: 'center',
              change: this.openImgStatusChange
            },
            {
              label: '是否可用',
              prop: 'status',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('mallNavigationCategory.status')
            },
          ],
          url: api.mall.navigationCategory
        },
        // 添加字段
        addColumns: {
          labelWidth: '350px',
          span: 24,
          columns: [
            {
              label: '基本信息',
              type: 'title',
              prop: '',
            },
            {
              label: '导航栏标题',
              type: 'input',
              prop: 'name',
            },
            {
              label: '导航栏图片',
              type: 'image',
              prop: 'imgUrl',
              limit: 1,
              callback: this.setImageData,
            },
            {
              label: '导航栏类型',
              type: 'select',
              prop: 'type',
              align: "center",
              data: this.$utils.getCacheStatus('mallNavigationCategory.type'),
              change: this.typeChange
            },
            {
              label: '商品分类',
              type: 'select',
              prop: 'retaleId',
              align: "center",
              data: [],
              isShow: false,
              url: api.archives.categoryList,
              param: {parentId: 0},
              change: this.retaleChange
            },
            {
              label: '功能入口',
              type: 'select',
              prop: 'functionType',
              data: this.$utils.getCacheStatus('mallNavigationCategory.functionType'),
              align: "center",
              isShow: false,
              change: this.functionTypeChange
            },
            {
              label: '关联商品',
              type: 'select',
              prop: 'goodsId',
              data: [],
              align: "center",
              url: api.archives.goodsInfo,
              param: {merchantId: this.$utils.getSysUser().merchantId, storeId: this.$utils.getSysUser().storeId},
              isShow: false,
              change: this.goodsChange,
            },
            {
              label: '其他链接地址',
              type: 'input',
              prop: 'urlStr',
              align: "center",
              isShow: false,
            },
            {
              label: '排序',
              type: 'input',
              prop: 'orderNo',
              align: "center",
            },
            {
              label: "状态",
              prop: "status",
              type: "radio",
              defaultValue: 10,
              align: "center",
              data: this.$utils.getCacheStatus('mallNavigationCategory.status'),
            },
          ], // 表单label
          url: api.mall.navigationCategory
        },
      };
    },
    created() {
    },
    methods: {
      setImageData(formModel, fileList) {
        formModel.imgUrl = fileList[0].response;
      },
      typeChange(data) {
        let retaleId = this.addColumns.columns.filter(item => item.prop == "retaleId")[0];
        let urlStr = this.addColumns.columns.filter(item => item.prop == 'urlStr')[0];
        let functionType = this.addColumns.columns.filter(item => item.prop == 'functionType')[0];
        let goodsId = this.addColumns.columns.filter(item => item.prop == 'goodsId')[0];
        switch (data.type) {
          case 10:
            retaleId.isShow = true;
            urlStr.isShow = false;
            data.urlStr = '';
            functionType.isShow = false;
            data.functionType = '';
            goodsId.isShow = false;
            data.goodsId = '';
            break;
          case 20:
            retaleId.isShow = false;
            data.retaleId = '';
            urlStr.isShow = false;
            data.urlStr = '';
            functionType.isShow = true;
            break;
          case 30:
            retaleId.isShow = false;
            data.retaleId = '';
            urlStr.isShow = true;
            functionType.isShow = false;
            data.functionType = '';
            goodsId.isShow = false;
            data.goodsId = '';
            break;
          default:
            console.log("未知类型");
        }
      },
      functionTypeChange(data) {
        let goodsId = this.addColumns.columns.filter(item => item.prop == 'goodsId')[0];
        if (data.functionType === 20) {
          goodsId.isShow = true;
        } else {
          goodsId.isShow = false;
          data.goodsId = '';
        }
        let functionType = this.$utils.getCacheStatus('mallNavigationCategory.functionType');
        functionType.forEach(item => {
          if (item.value === data.functionType) {
            this.$refs["scalesTemplate"].$refs["formTemplate"].formModel.typeDesc = item.label;
          }
        });
      },
      retaleChange(data) {
        this.$refs["scalesTemplate"].$refs["formTemplate"].formModel.typeDesc = data.retaleName;
      },
      goodsChange(data) {
        this.$refs["scalesTemplate"].$refs["formTemplate"].formModel.goodsName = data.goodsName;
      },
      openImgStatusChange(row) {
        this.$axios.fetchPut(api.mall.navigationCategory, row).then(data => {
          if (data.code === 200) {
            this.loading = false;
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '修改成功', type: 'success'});
          } else {
            this.$notify({
              type: "error",
              title: '修改操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '修改失败', type: 'error'});
          }
        }).catch((err) => {
          this.loading = false;
          this.$notify({
            type: "error",
            title: '修改操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '修改失败', type: 'error'});
        });
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/mall/setting/Category.vue